import React from 'react';
import { Link } from 'react-router-dom';
import { useIsAnkrAdmin, useIsSalesUser } from '../../context/AuthContext';


const PermissionDeniedPage = () => {
  const isAnkrAdmin = useIsAnkrAdmin();
  const isSalesUser = useIsSalesUser();

  const homeLink = isSalesUser ? '/admin/sales/leads' : isAnkrAdmin ? '/admin' : '/';

  return (
    <>
      <div className="text-center">
        <div className="mb-4">
          <i className="fas fa-lock text-danger" style={{ fontSize: '4rem' }}></i>
        </div>
        <h1 className="mb-4">Permission Denied</h1>
        <p className="lead mb-4">
          You do not have permission to access this page. This feature is restricted to Ankr administrators only.
        </p>
        <p>
          If you believe you should have access to this page, please contact your system administrator.
        </p>
        <div className="mt-4">
          <Link to={homeLink} className="btn btn-primary">
            Return to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default PermissionDeniedPage;